import React from "react";
import QCLogo from "../../assets/images/qc-logo.png";
import marlonPngInitial from "../../images/marlonPngInitial.png"
import { API, graphqlOperation,Auth } from "aws-amplify";
import { getCreateOrderOfBilling } from "../../graphql/queries";
import VELASCOMichael from "../../images/Michael_V_Velazco_OIC_ZAU.png";

import Swal from "sweetalert2";

import "./SUPForm.scss";

const url = new URL(window.location.href);
const this_id = url.searchParams.get("id");

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      applicationNo: "",
      projectActivity: "",
      lc_No: "",
      lotno: "",
      blkno: "",
      locationstreet: "",
      locationbarangay: "",
      locationdistrict: "",
      zoneclassification: "",
      owner: "",
      lot_area: "",
      floor_area: "",
      noofunits: "",
      tctno: "",
      evaluationfacts: "",
      evaluation_facts_extended: "",
      application_zone: [],
      dataArchitectural: {},
      dataZoning: {},
      dataActualInspection: {},
      user: {},
      project_name: "",
      nothingFollows: "",
      image: "",
      signedImage: "",
      blankWhiteImage: "",
      isBlankImage: false,
      checklistId: null,
      qcUserId: null,
      lc_number: null,
      datePaid: "",
      finalPaymentAmount: 0,
      OrNumber: "",
      OrDate: "",
      grandTotal: "",
      signatureDate2: "",
      signatureDate1: "",
      status:""
    };
  }

  componentDidMount() {
    try {
      const fetchLocation = async () => {
        
        const userData = await Auth.currentAuthenticatedUser();
        
        if (!userData) {
            Swal.fire({
              title: 'Not Logged In',
              text: 'Please log in to access the user profile.',
              icon: 'warning',
              confirmButtonText: 'OK',
            }).then(() => {
              localStorage.clear()
              window.location.reload();
            });
        }

        const result = await API.graphql(
          graphqlOperation(getCreateOrderOfBilling, { id: this_id })
        );
      
        this.setState((prev) => {
          const newState = { ...prev };
          const {
            application_no,
            project_activity,
            lcNo,
            lot_no,
            blk_no,
            location_street,
            location_barangay,
            location_district,
            zone_classification,
            owner,
            lot_area,
            floor_area,
            no_of_units,
            tct_no,
            evaluation_facts,
            evaluation_facts_extended,
            OrNumber,
            OrDate,
            grandTotal,
            signatureDate2,
            signatureDate1,
            status
          } = result.data.getCreateOrderOfBilling;

          const ifParsable = this.isStringParsable(tct_no);
          const tctNew = !ifParsable ? tct_no : ifParsable;
          
          newState.applicationNo = application_no;
          newState.projectActivity = project_activity;
          newState.lc_No = lcNo;
          newState.lotno = lot_no;
          newState.blkno = blk_no;
          newState.locationstreet = location_street;
          newState.locationbarangay = location_barangay;
          newState.locationdistrict = location_district;
          newState.zoneclassification = zone_classification;
          newState.lotarea = lot_area;
          newState.owner = owner;
          newState.floorarea = floor_area;
          newState.noofunits = no_of_units;
          newState.tctno = tctNew;
          newState.evaluationfacts = evaluation_facts;
          newState.evaluation_facts_extended = evaluation_facts_extended;
          newState.OrNumber = OrNumber;
          newState.OrDate = OrDate;
          newState.grandTotal = grandTotal;
          newState.signatureDate2 = signatureDate2;
          newState.signatureDate1 = signatureDate1;
          newState.status = status;
          return newState;
        });
      };
      fetchLocation();
    } catch (error) {
      console.log(error);
    }
  }
  isStringParsable(str) {
    try {
      let x = JSON.parse(str);
      return x.joins(",");
    } catch (error) {
      return false;
    }
  }

  downloadThis() {
    document.getElementById("printOption").style.visibility = "hidden";
    window.print();
    document.getElementById("printOption").style.visibility = "visible";
  }

  render() {
    let {
      applicationNo,
      projectActivity,
      lc_No,
      lotno,
      blkno,
      locationstreet,
      locationbarangay,
      locationdistrict,
      zoneclassification,
      lotarea,
      owner,
      floorarea,
      noofunits,
      tctno,
      OrNumber,
      OrDate,
      evaluationfacts,
      signedImage,
      grandTotal,
      signatureDate2,
      status,
      blankWhiteImage,
      isBlankImage,
      evaluation_facts_extended,
    } = this.state;

    let nothingFollows = "Nothing follows";
    nothingFollows = `-\xa0\xa0\xa0\xa0\xa0\xa0\xa0${nothingFollows}\xa0\xa0\xa0\xa0\xa0\xa0\xa0-`;
    

  
    return (
      <>
        {(status === "6" || status === "5" ||  status === "4") && 
         <>
          <div
          className="container-fluid noprint noprint hidden-print"
          id="printOption"
        >
          <button
            onClick={this.downloadThis}
            className="btn btn-block btn-primary"
          >
            Print
          </button>
        </div>
        <div className="LCForm">
          <div className="lc-header">
            <div className="image-width">
              <img className="qc-logo" src={QCLogo} alt="qc-logo" />
            </div>
            <div className="qc-header" style={{fontWeight: 'bold'}}>
              <p>Republic of the Philippines</p>
              <p className="pb-1">QUEZON CITY</p>
              <p>CITY PLANNING AND DEVELOPMENT OFFICE</p>
              <p className="pb-1">ZONING ADMINISTRATION UNIT</p>
              <p>LOCATIONAL CLEARANCE</p>
              <p>WITH</p>
              <p>SPECIAL USE PERMIT</p>
            </div>
          </div>
          <div className="lc-number py-0">
            <p className="mb-0">
              <b>SUP NO. <u>{lc_No && lc_No}</u></b>
            </p>
          </div>

          <main className="fw-bold">

            {/* Application Info */}
            <section className="mb-2">
              <div className="row">
                <div className="col">
                  <span>Application No:</span>
                  <span className="ml-3 border-bottom">{applicationNo ? applicationNo : ''}</span>
                </div>

                <div className="col text-right">
                  <span>Date Issued:</span>
                  <span className="ml-3 border-bottom">
                    {applicationNo && signatureDate2 ? (
                      new Date(signatureDate2).toLocaleDateString("en-us", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    ) :   (
                      new Date().toLocaleDateString("en-us", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    )}
                  </span>
                </div>
              </div>
            </section>

            {/* Project Info */}
            <section className="px-3 border mb-3">
              <div className="row border-bottom p-0">
                <div className="col border-right px-3">
                  {/* Project Activity */}
                  <div className="row">
                    <div className="col">
                      <span>Project Activity:</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span>{projectActivity ? projectActivity?.toUpperCase() : ''}</span>
                    </div>
                  </div>

                </div>

                <div className="col">
                  {/* Owner */}
                  <div className="row">
                    <div className="col">
                      <span>Owner:</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span>{owner ? owner.toUpperCase() : ''}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row border-bottom p-0">
                <div className="col px-3">
                  {/* Location */}
                  <div className="row">
                    <div className="col">
                      <span>Location:</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span className="px-5">
                        {`${lotno !== '-' ? "LOT " + lotno : ''} ${blkno !== '-' ? "BLK " + blkno : ''} ${locationstreet.toUpperCase()} BRGY. ${locationbarangay.toUpperCase()} DISTRICT ${locationdistrict} QUEZON CITY`}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row border-bottom p-0 ">
                <div className="col border-right px-3">
                  {/* TCT No */}
                  <div className="row"> 
                    <div className="col">
                      <span>TCT No:</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span>{tctno ? tctno : ''}</span>
                    </div>
                  </div>

                </div>

                <div className="col border-right px-3">
                  {/* Lot Area */}
                  <div className="row">
                    <div className="col">
                      <span>Lot Area (sq. m.):</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span>{lotarea && lotarea.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                    </div>
                  </div>
                </div>

                <div className="col border-right px-3">
                  {/* Floor Area */}
                  <div className="row">
                    <div className="col text-center">
                      <span>Floor Area (sq. m.):</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span>{floorarea && floorarea.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                    </div>
                  </div>

                </div>

                <div className="col px-3">
                  {/* Zone Classification */}
                  <div className="row">
                    <div className="col">
                      <span>Zone Classification:</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span>{zoneclassification && zoneclassification.replace(/\[|\]/g, '').replace(/,/g,"&")}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  {/* Evaluation Of Facts */}
                  <div className="row">
                    <div className="col">
                      <span>Evaluation of Facts:</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span>
                        {evaluationfacts && evaluationfacts.toLocaleUpperCase()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Signature */}
            <section className="mb-3">
              <div className="row">
                <div className="col pl-5">
                  <div className="row mb-1">
                    <div className="box mx-5">
                      
                    </div>
                  </div>
                  <div className="row">
                    <small className="mx-4">NOT VALID WITHOUT SEAL</small>
                  </div>
                </div>
                <div className="col text-right pr-5">
                  <div className="row">
                    <div className="col text-center">
                      {isBlankImage === true ? (
                        <>
                          <img
                            src={signedImage}
                            className="img-fluid visible-no-print"
                            alt="blank"
                          />
                          <img
                            src={blankWhiteImage}
                            className="img-fluid visible-print"
                            alt="blank"
                          />
                        </>
                      ) : (
                        <img
                          src={VELASCOMichael}
                          width="200px"
                          height="90px"
                          className="img-fluid img-custom"
                          alt="blank"
                          style={{ transform: 'rotate(370deg)' }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span>MR. MICHAEL B. VELASCO</span>
                      <span><img src={marlonPngInitial} width="50" height="50" alt=""/></span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <span>OIC - ZONING ADMINISTRATION UNIT</span>
                    </div>       
                  </div>
                </div>
              </div>
            </section>

          </main>
          
          <div>
            <div className="w-100 text-center">
              <p className="large-font">
                <b>
                  <u>CONDITIONS</u>
                </b>
              </p>
            </div>
            <div className="conditions">
              <table className="small-font table-borderless">
                <tbody>
                  <tr>
                    <td className="align-top">1.</td>
                    <td className="col">
                      That this Clearance shall be posted in a conspicuous place
                      within the premises/building during construction and after
                      occupancy.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">2.</td>
                    <td className="col">
                      That the proponent cannot undertake any activity other
                      than those applied for without the approval from this
                      Office.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">3.</td>
                    <td className="col">
                      That any material falsehood or misrepresentation in the
                      submitted documents made in connection with this Clearance
                      shall render this Null and Void.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">4.</td>
                    <td className="col">
                      That the Implementation of the project shall commence
                      within the period of one year from the date of issuance of
                      this Clearance; otherwise the proponent shall re-apply for
                      a new Clearance.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">5.</td>
                    <td className="col">
                      That this Office reserves the right to inspect and review
                      said project/operation and should there be any violation
                      found, to institute cancellation proceedings.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">6.</td>
                    <td className="col">
                      That no additional activity/project floor area than
                      indicated in this Clearance shall be made/utilized without
                      approval from this Office.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">7.</td>
                    <td className="col">
                      That the pertinent provisions of the National Building
                      Code (PD 1096) and the Quezon City Zoning Ordinance
                      relative to required parking space; height restriction,
                      easement, open spaces, setbacks and other provisions shall
                      be complied with.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">8.</td>
                    <td className="col">
                      That any violation of these conditions will mean the
                      suspension or cancellation/revocation of this Clearance,
                      subject to legal action (criminal and/or administrative)
                      as applicable under local and national laws.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">9.</td>
                    <td className="col">
                      That this Clearance can be revoked in the interest of the
                      general public.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">10.</td>
                    <td className="col">
                      That all conditions stipulated herein from part of this
                      decision and are subject to monitoring.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">11.</td>
                    <td className="col">
                      This Clearance shall not be construed as a certification
                      of the Zoning Administrative Unit as to the ownership by
                      the applicant of the parcel of land subject of the
                      Clearance.
                    </td>
                  </tr>
                  <tr>
                    <td className="align-top">12.</td>
                    <td className="col">
                      That this Clearance/Permit does not exempt the project
                      from the pertinent requirements of other government
                      agencies.
                    </td>
                  </tr>
                </tbody>
              </table>
              <img
                className="watermark-image"
                src={QCLogo}
                alt="QC Logo Watermark"
              />
            </div>
            <div className="w-100 text-center">
              <p className="large-font mb-0">{nothingFollows}</p>
            </div>
            <div className="table-centered">
              <center>
                <table className="small-font table-borderless">
                  <tbody>
                    <tr>
                      <td className="text-left col-5">
                        <b>OR No:</b>
                      </td>
                      <td>
                        <b>
                          <span className="styled-underline col">
                            {OrNumber !== "0" ? OrNumber : ""}
                          </span>
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-left col-5">
                        <b>Date Paid :</b>
                      </td>
                      <td>
                        <b>
                          <span className="styled-underline col">
                            {OrNumber !== "0"
                              ? new Date(OrDate).toLocaleDateString()
                              : ""}
                          </span>
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-left col-5">
                        <b>Amt Paid :</b>
                      </td>
                      <td>
                        <b>
                          <span className="styled-underline col">
                            {OrNumber !== "0"
                              ? grandTotal !== 0
                                ? `P ${parseFloat(grandTotal).toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}`
                                : ""
                              : ""}
                          </span>
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </center>
            </div>
          </div>
        </div>
      </>
      }
      </>
    );
  }
}

export default ComponentToPrint;
